import { HistoryApi, useAPIQuery } from "melco-shared-logic";

export const useEmailPreview = (emailId: string) => {
  //const token = useUserToken();
  //const baseApiConfig = useBaseAPIConfig();
  //const api = new ControlCenterApi(baseApiConfig({ token }));
  console.log(emailId);
  return useAPIQuery(HistoryApi, ["emailPreviewById", emailId], async (api) => {
    // Uncomment after merge
    return api.manageGetEmail({ id: emailId });
  });
};
